import { useLang } from "@/context/LanguageContext";

export const RibbonMarquee = () => {
  const { t } = useLang();
  return (
    <section className="border-y border-navy/10 bg-canvas py-6 md:py-8" data-testid="marquee">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-6 gap-y-2 px-5 md:gap-x-10">
        {t.marquee.map((word, i, arr) => (
          <span key={word + i} className="flex items-center gap-6 md:gap-10">
            <span className="font-serif italic font-light text-navy text-2xl sm:text-3xl md:text-5xl">
              {word}
            </span>
            {i < arr.length - 1 && <span className="text-gold text-lg md:text-2xl">✦</span>}
          </span>
        ))}
      </div>
    </section>
  );
};
